module.exports = __webpack_public_path__ + "media/images/vp/parallax.temp.04-49e8baa7b8c16ae1146bd695d9dea6ce.svg";